import React, { useState } from 'react';
import CategoryReport from './CategoryReport';
import DepartmentCardReport from './DepartmentCardReport';
import TotalMaterialReport from './TotalMaterialReport';
import DepartmentView from './DepartmentView';
import GroupView from './GroupView';

const TABS = [
  { key: 'category', label: 'Category', Comp: CategoryReport },
  { key: 'deptcard', label: 'Dept Cards', Comp: DepartmentCardReport },
  { key: 'material', label: 'Materials', Comp: TotalMaterialReport },
  { key: 'bydept', label: 'By Department', Comp: DepartmentView },
  { key: 'bygroup', label: 'By Group', Comp: GroupView },
];

export default function ReportsHub() {
  const [tab, setTab] = useState('category');
  const Active = TABS.find(t => t.key === tab).Comp;
  return (
    <div>
      <div className="tabs" style={{ marginBottom: 16 }}>
        {TABS.map(t => (
          <button key={t.key} className={`tab ${tab === t.key ? 'active' : ''}`} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>
      <Active />
    </div>
  );
}
